import React from "react";
import Navbar from "./components/navbar";
import Footer from "./components/footer";
import Banner from "./components/banner";
import CreateComponent from "./create/create.component";
import CreateProvider from "./create/provider/create.provider";

const SamsungCarePlus = () => {
  return (
    <>
      <Navbar />
      <Banner />
      <main className="flex flex-1 items-center justify-center pb-8 md:px-4 md:pt-24">
        <div className="container max-w-7xl">
          <CreateProvider>
            <CreateComponent />
          </CreateProvider>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default SamsungCarePlus;
